const SkeletonPage = () => {
  return (
    <div className="min-h-screen animate-pulse">
      {/* Hero Skeleton */}
      <div className="w-full h-[500px] md:h-[600px] bg-gray-200"></div>
      
      {/* Content Skeleton */}
      <div className="max-w-7xl mx-auto px-4 py-16 space-y-8">
        {/* Title */}
        <div className="h-8 bg-gray-200 rounded w-64 mx-auto"></div>
        
        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-8">
          {[...Array(6)].map((_, i) => (
            <div key={i} className="bg-gray-200 rounded-lg h-80"></div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SkeletonPage;
